import styled from '@emotion/styled';
import { Col, Card, Row } from 'antd';

const { Grid } = Card;

export const PolicyCardContainer = styled(Card)`
  box-shadow: 0 2px 8px #00000017;
  width: 100%;
`;

export const CardCol = styled(Col)`
  &:first-of-type {
    border-bottom: 1px solid #00000017;
  }

  @media (min-width: 768px) {
    &:first-of-type {
      border-bottom: 0px;
      border-right: 1px solid #00000017;
    }
  }
`;

export const PolicyCardGrid = styled(Grid)`
  width: 100%;
  box-shadow: none;
  padding: ${props => props.spacingBeforeContent || 0} 0 0 0;

  @media (min-width: 768px) {
    padding: 0 0 0 ${props => props.spacingBeforeContent || 0};
  }
`;

export const Title = styled.p`
  color: ${props => props.theme.color.primary};
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeight.bold};
  margin-bottom: 0px;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeight.bold};
  margin-bottom: 0px;
`;

export const TitleCol = styled(Col)`
  margin-bottom: ${props => props.theme.spacing.regular};
`;

export const DescriptionCol = styled(Col)`
  margin-bottom: ${props => props.theme.spacing.xs};
`;

export const Description = styled.p`
  color: ${props => (props.highlight ? props.theme.color.primary : props.theme.color.black)};
  font-weight: ${props => props.theme.fontWeight.light};
  margin-bottom: 0px;
`;

export const BenefitRow = styled(Row)`
  margin-bottom: ${props => props.theme.spacing.xxs};
`;
